import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { TruckOwnerService } from "../truck-owner.service";
import { TrucksAddComponent } from "../trucks-add/trucks-add.component";
import { TrucksViewComponent } from "../trucks-view/trucks-view.component";

@Component({
  selector: "app-trucks",
  templateUrl: "./trucks.component.html",
  styleUrls: ["./trucks.component.css"],
})
export class TrucksComponent implements OnInit {
  Matdialogref!: MatDialogRef<TrucksViewComponent>;
  matDialogref!: MatDialogRef<TrucksAddComponent>;

  truckType: any = "-1";
  token: any;
  trucksArray: any;
  document_array: any = [];
  fetch_page: any = 0;
  currentPage: any = 0;
  startPage: any = 1;
  last_page: any = 1;
  truckNumber: any = -1;
  loading: boolean = false;
  search_btn: boolean = true;
  clear_btn: boolean = false;
  perpage: any = 10;
  @ViewChild("newItem") newItem!: ElementRef;
  constructor(
    private matDialog: MatDialog,
    private services: TruckOwnerService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("to_token");
    this.trucksGet(this.truckType);
    let triptype = "trucks";
    sessionStorage.setItem("tripType", triptype);
    if (this.token == null) {
      this.router.navigateByUrl("/");
    }
    this.pagination(1);
  }
  getTripsList(selectedTripType: any) {
    this.truckType = selectedTripType;
    if (this.truckType == "-1") {
      this.fetch_page = 1;
      this.startPage = 1;
      // this.truckNumber = -1;
      this.trucksGet(this.truckNumber);
      this.document_array = [];
    } else if (this.truckType == "allocated") {
      this.fetch_page = 1;
      this.startPage = 1;
      // this.truckNumber = -1;
      this.trucksGet(this.truckNumber);
      this.document_array = [];
    } else if (this.truckType == "available") {
      this.fetch_page = 1;
      this.startPage = 1;
      // this.truckNumber = -1;
      this.trucksGet(this.truckNumber);
      this.document_array = [];
    } else if (this.truckType == "underVerification") {
      this.fetch_page = 1;
      this.startPage = 1;
      // this.truckNumber = -1;
      this.trucksGet(this.truckNumber);
      this.document_array = [];
    } else if (this.truckType == "maintenance") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.trucksGet(this.truckNumber);
      // this.truckNumber = -1;
      this.document_array = [];
    }
  }

  addTruck() {
    this.matDialogref = this.matDialog.open(TrucksAddComponent, {
      width: "80vw",
      height: "80vh",
      autoFocus: false,
    });
  }
  trucksGet(type: any) {
    this.truckNumber = type;
    this.loading = true;

    this.services
      .getTruckownerTrucks(
        this.token,
        this.truckType,
        this.truckNumber,
        this.startPage,
        this.perpage
      )
      .subscribe(
        (response: any) => {
          this.trucksArray = response.body.data;
          this.document_array.push(response.body.meta);
          this.last_page = response.body.meta.lastPage;
          this.loading = false;
        },
        (error) => {
          this.trucksArray = [];
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
        }
      );
  }

  viewTruck(item: any) {
    this.Matdialogref = this.matDialog.open(TrucksViewComponent, {
      width: "80vw",
      height: "80vh",
      data: item,
      autoFocus: false,
    });
    this.Matdialogref.afterClosed().subscribe((x) => {
      this.trucksGet(this.truckNumber);
    });
  }

  deleteTruck(id: any) {
    this.services.truckDelete(id, this.token).subscribe(
      (response: any) => {
        if (response.status == 200) {
          this.trucksGet(this.truckNumber);
        }
      },
      (error) => {
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
        if (error.status == 404) {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
        }
        if (error.status == 500) {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
        }
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
        }
      }
    );
  }

  search(value: any) {
    if (value != "") {
      this.search_btn = false;
      this.clear_btn = true;
      this.trucksGet(value);
    }
  }

  resetSearch() {
    this.newItem.nativeElement.value = "";
    this.search_btn = true;
    this.clear_btn = false;
    this.truckType = -1;
    this.trucksGet(this.truckType);
  }

  pagination(page_status: any) {
    if (page_status == "-1") {
      this.fetch_page = parseInt(this.fetch_page) - 1;
      this.currentPage = this.fetch_page;
      this.startPage = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.fetch_page) + 1;
      this.fetch_page = this.currentPage;
      this.startPage = this.fetch_page;
    }
    if (page_status == "first") {
      this.fetch_page = this.document_array[0].currentPage;
      this.startPage = this.document_array[0].currentPage;
    }
    if (page_status == "last") {
      this.fetch_page = this.document_array[0].lastPage;
      this.startPage = this.document_array[0].lastPage;
    }
    this.trucksGet(this.truckNumber);
  }
}
